import { debugLog } from "@lululemon/auth-common";
// Update analytics authState (evar21) in localStorage
export var setAnalyticsAuthState = function (value) {
    debugLog({ message: "Updating AuthState to \"".concat(value, "\"") });
    localStorage.setItem("lll-auth-state", value);
    window.lllAuthStateReady = true;
    window.dispatchEvent(new CustomEvent("lll-auth-state-ready"));
};
export var readAnalyticsAuthState = function (authState) {
    var isAuthenticated = authState.isAuthenticated, authorizationLevel = authState.authorizationLevel;
    return isAuthenticated
        ? authorizationLevel === "full"
            ? "authenticated"
            : "authenticated:partial-login"
        : "guest";
};
